<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div>
  <profile-pds-p-text p-text id="required-fields-hint">{{ 'pidaw.generic.form.requiredFields.hint' | translate }}</profile-pds-p-text>
  <div>
    <form
      [formGroup]="dateOfBirthFormGroup"
      class="profile:mt-fluid-md"
      myprofileUiValidationTrack="birthday_editform"
      id="form"
      [attr.aria-label]="'birthdayWidget.editBirthday.headline' | translate"
      aria-describedby="required-fields-hint"
    >
      <profile-pds-p-input-date
        p-input-date
        id="dateOfBirthInputField"
        name="dateOfBirth"
        class="fs-exclude"
        formControlName="dateOfBirth"
        [attr.aria-label]="'birthdayWidget.input.label' | translate"
        [attr.data-e2e]="'birthday-widget-input-date'"
        [attr.data-has-error]="!!dateOfBirthFormControlErrorMessage"
        [state]="!!dateOfBirthFormControlErrorMessage ? 'error' : 'none'"
        [message]="dateOfBirthFormControlErrorMessage"
        [min]="minDate"
        [max]="maxDate"
        (change)="onDateChange($event)"
      >
      </profile-pds-p-input-date>

      <div class="profile:flex profile:flex-col profile:gap-y-fluid-sm profile:sm:gap-x-static-sm profile:sm:flex-row profile:mt-fluid-md">
        <profile-pds-p-button
          [aria]="{ 'aria-label': ('birthdayWidget.button.save.aria' | translate) }"
          p-button
          variant="primary"
          (click)="submit()"
          icon="check"
          [myprofileUiTrack]="{
            clickElementType: 'button',
            clickElementId: 'date_of_birth',
            clickElementName: 'save',
          }"
        >
          {{ 'birthdayWidget.button.save.label' | translate }}
        </profile-pds-p-button>
        <profile-pds-p-button
          [aria]="{ 'aria-label': ('birthdayWidget.button.cancel.aria' | translate) }"
          p-button
          variant="secondary"
          (click)="triggerCancel()"
          icon="close"
          [myprofileUiTrack]="{
            clickElementType: 'button',
            clickElementId: 'date_of_birth',
            clickElementName: 'cancel',
          }"
        >
          {{ 'birthdayWidget.button.cancel.label' | translate }}
        </profile-pds-p-button>
      </div>
    </form>
  </div>
</div>
